import React, { useState, useEffect } from 'react'
import { useInView } from 'react-cool-inview'
import { string } from 'prop-types'

// To Do: this is a temprorary component to provide password strength in fast pages,
// it will be used untill navbars are unified.

let ReactPasswordStrengthNew

function PasswordFieldWithCheck({ customId, customName }) {
  const [currentState, setState] = useState({
    isLoaded: false,
    value: '',
    error: '',
  })

  const { observe, inView } = useInView({
    threshold: 0.25,
    onEnter: ({ unobserve }) => {
      unobserve() // unobserve to avoid multiple loads if dropdown closed and opened again
    },
  })

  useEffect(() => {
    if (inView && !ReactPasswordStrengthNew) {
      import('Pods/Shared/ReactPasswordStrengthNew')
        .then((module) => {
          ReactPasswordStrengthNew = module.default
          setState((prevState) => ({ ...prevState, isLoaded: true }))
        })
        .catch((err) => {
          // To do:
          // sentry error here.
        })
    }
  }, [inView])

  function handlePasswordChange(state) {
    setState((prevState) => ({ ...prevState, value: state.password }))
  }

  return (
    <div ref={observe}>
      {currentState.isLoaded && !!ReactPasswordStrengthNew && (
        <ReactPasswordStrengthNew
          minLength={6}
          className="cgt-text-input cgt-text-input--medium cgt-text-input--primary cgt-text-input--icon-trail cgt-text-input--not-spaced cgt-text-input--password"
          inputProps={{
            placeholder: '******',
            id: customId,
            name: customName,
            required: 'required',
          }}
          changeCallback={handlePasswordChange}
        />
      )}
    </div>
  )
}

PasswordFieldWithCheck.propTypes = {
  customId: string.isRequired,
  customName: string.isRequired,
}

export default PasswordFieldWithCheck
